export default {
    first: 'tracking.first',
    last: 'tracking.last',
    sgTracking: 'tracking.sg'
};